import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Graph: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_28350)'>
        <path
          d='M5.28986 16.22H2.33217C2.16907 16.22 2.03691 16.3531 2.03691 16.5173V22.7027C2.03691 22.8669 2.16907 23 2.33217 23H5.28986C5.45296 23 5.58512 22.8669 5.58512 22.7027V16.5173C5.58512 16.3531 5.45296 16.22 5.28986 16.22ZM4.9946 22.4054H2.62744V16.8146H4.9946V22.4054ZM10.7614 10.4331H7.80374C7.64064 10.4331 7.50848 10.5662 7.50848 10.7304V22.5622C7.50848 22.7264 7.64064 22.8595 7.80374 22.8595H10.7614C10.9245 22.8595 11.0567 22.7264 11.0567 22.5622V10.7304C11.0567 10.5662 10.9246 10.4331 10.7614 10.4331ZM10.4662 22.2649H8.09905V11.0277H10.4662V22.2649ZM16.233 12.4014H13.2754C13.1123 12.4014 12.9801 12.5345 12.9801 12.6987V22.4216C12.9801 22.5859 13.1123 22.7189 13.2754 22.7189H16.233C16.3961 22.7189 16.5283 22.5859 16.5283 22.4216V12.6987C16.5283 12.5345 16.3961 12.4014 16.233 12.4014ZM15.9378 22.1244H13.5706V12.996H15.9378V22.1244ZM21.7047 6.91856H18.747C18.5839 6.91856 18.4517 7.05163 18.4517 7.21586V22.281C18.4517 22.4453 18.5839 22.5783 18.747 22.5783H21.7047C21.8678 22.5783 22 22.4453 22 22.281V7.21586C22 7.05163 21.8678 6.91856 21.7047 6.91856ZM21.4095 21.9837H19.0422V7.51316H21.4095V21.9837ZM14.7173 9.66082C15.6955 9.66082 16.4913 8.8595 16.4913 7.87461C16.4913 7.4799 16.362 7.11591 16.1459 6.8199L19.0818 4.17973C19.3856 4.42495 19.7702 4.57255 20.189 4.57255C21.1672 4.57255 21.963 3.77114 21.963 2.78617C21.963 1.80132 21.1672 1 20.1889 1C19.2107 1 18.4149 1.80132 18.4149 2.78621C18.4149 3.13538 18.5164 3.46039 18.6891 3.73586L15.722 6.40392C15.4361 6.20523 15.0902 6.08819 14.7173 6.08819C14.0708 6.08819 13.5057 6.43933 13.1956 6.96101L10.9913 6.09932C11.0089 5.99847 11.0198 5.89534 11.0198 5.78955C11.0198 4.80458 10.2239 4.00326 9.2457 4.00326C8.26757 4.00326 7.47174 4.80458 7.47174 5.78955C7.47174 6.16798 7.58999 6.51865 7.79017 6.80787L4.73928 9.81431C4.46118 9.63186 4.13003 9.52474 3.77404 9.52474C2.79583 9.52474 2 10.3261 2 11.311C2 12.2959 2.79583 13.0972 3.77404 13.0972C4.75226 13.0972 5.54817 12.2959 5.54817 11.311C5.54817 10.899 5.4076 10.5203 5.17405 10.2178L8.20381 7.23223C8.49677 7.44738 8.85621 7.57598 9.24574 7.57598C9.91013 7.57598 10.4896 7.20576 10.7936 6.65993L12.9795 7.51445C12.9558 7.63081 12.9433 7.75125 12.9433 7.87461C12.9432 8.8595 13.739 9.66082 14.7173 9.66082ZM3.77396 12.5026C3.12134 12.5026 2.59044 11.9681 2.59044 11.311C2.59044 10.6539 3.12134 10.1193 3.77396 10.1193C4.42665 10.1193 4.95756 10.6539 4.95756 11.311C4.9576 11.9681 4.4267 12.5026 3.77396 12.5026ZM9.24565 6.98138C8.59313 6.98138 8.06222 6.44681 8.06222 5.7896C8.06222 5.13248 8.59313 4.5979 9.24565 4.5979C9.89835 4.5979 10.4293 5.13248 10.4293 5.7896C10.4293 6.44676 9.89835 6.98138 9.24565 6.98138ZM20.1889 1.5946C20.8415 1.5946 21.3724 2.12918 21.3724 2.78621C21.3724 3.44342 20.8415 3.97799 20.1889 3.97799C19.5363 3.97799 19.0054 3.44342 19.0054 2.78621C19.0054 2.12918 19.5363 1.5946 20.1889 1.5946ZM14.7173 6.68283C15.3699 6.68283 15.9008 7.21741 15.9008 7.87461C15.9008 8.53165 15.3699 9.06622 14.7173 9.06622C14.0647 9.06622 13.5337 8.53165 13.5337 7.87461C13.5337 7.21741 14.0647 6.68283 14.7173 6.68283Z'
          fill='url(#paint0_linear_12280_28350)'
          stroke='url(#paint1_linear_12280_28350)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_28350'
          x1='6.14154'
          y1='2.50015'
          x2='16.7266'
          y2='21.7869'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28350'
          x1='6.14154'
          y1='2.50015'
          x2='16.7266'
          y2='21.7869'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_28350'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Graph;
